export default __webpack_public_path__ + "static/ak-cached/24h/media/250visacard.4e423e28.png";